(function (ws, win) {
    'use strict';
    ws.views.productavailable = Backbone.View.extend({

        /**
         * event handlers
         */
        events: {
            'click .comp-tooltip-label': 'renderAvailable',
            'mouseover .comp-tooltip-label': 'renderAvailable',
            'mouseout .comp-tooltip-label': 'closeTooltip',
            'touchstart .comp-tooltip-label': 'renderAvailable',
            'touchend .comp-tooltip-label': 'closeTooltip'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.template = _.template($('#product-available-tooltip').html());
            this.$el = this.$('.cpa-list');
            this.$spinner = this.$('.mic-spinner');
            this.$apiError = this.$('.api-error-message');
        },

        /**
         * Fetch Data Model
         */
        fetchData: function () {
            this.$spinner.show();
            this.model.fetch({
                success: this.render.bind(this),
                error: this._handleFetchError.bind(this)
            });
        },

        /**
         * Alerts you when there's error fetching the product availability
         * @protected
         */
        _handleFetchError: function () {
            this.$apiError.show();
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template(this.model.toJSON()));
            this.$spinner.hide();
            this.$apiError.hide();
        },

        /**
         * Resize window css
         * @param {Object} e
         */
        renderAvailable: function (e) {
            this.model = new ws.models.productavailable({
                productId: $(e.target).parents('.cpa-prodavailable').find('.productId').val(),
                displayMessage: $(e.target).parents('.cpa-prodavailable').find('.displayMessage').val()
            });
            this.fetchData();
            this.openTooltip(e);
        },

        /**
         * open Tooltip
         */
        openTooltip: function (e) {
            var $el = $(e.target);
            $el.next().show();
            $el.parent().next().show();
        },

        /**
         * close Tooltip
         */
        closeTooltip: function (e) {
            var $el = $(e.target);
            $el.next().hide();
            $el.parent().next().hide();
        }
    });
})(westcon, window);
